import Vue from 'vue'
import VueRouter from 'vue-router'
import { coupassMenuTitle } from '@/views/backend/Logis/coupassMenu'
import store from '@/store'
import { canSeeScreen } from '@/utils/screenAuth'   // 수강생 화면 권한 표 — 사이드바·서버 API·확장과 같은 원본

//Adding layouts router.
const BlankLayout = () => import("@/layouts/BlankLayout")
const NotFound = () => import('@/views/backend/Pages/NotFound')
const Layout1 = () => import("@/layouts/backend/Layout-1")

//Adding page content router.
const Dashbord = () => import('@/views/backend/main/Dashboard1')

//pages product
const ListProduct = () => import('@/views/backend/product/listproduct')
const RocketProductManagement = () => import('@/views/backend/product/rocketProductManagement')
const RocketSalesLedger = () => import('@/views/backend/product/rocketSalesLedger')
const MarketplaceSalesLedger = () => import('@/views/backend/marketplace/marketplaceSalesLedger')
const MarketplaceProductManagement = () => import('@/views/backend/marketplace/marketplaceProductManagement')
const MarketplaceScm = () => import('@/views/backend/marketplace/marketplaceScm')
const RocketScm = () => import('@/views/backend/product/rocketScm')
const AddProduct = () => import('@/views/backend/product/addproduct')
const RegProduct = () => import('@/views/backend/product/regproduct')
const Category = () => import('@/views/backend/product/category')
const CategoryMin = () => import('@/views/backend/product/category_min')

//pages AI
const AIpage = () => import('@/views/backend/AI/AIpage');
const AIpageV2 = () => import('@/views/backend/AI/AIpageV2');
const AIimage = () => import('@/views/backend/AI/AIimage');
const CleanUp = () => import('@/views/backend/AI/Cleanup');
const AIRocketReg = () => import('@/views/backend/AI/AIRocketReg');
const AIAssistant = () => import('@/views/backend/AI/AIAssistant');
const KnowledgeBaseManager = () => import('@/views/backend/AI/KnowledgeBaseManager');
const NanoBanana = () => import('@/views/backend/AI/NanoBanana');

//pages Categories
const ListCategory = () => import('@/views/backend/Categories/listcategory')
const AddCategory = () => import('@/views/backend/Categories/addcategory')

//pages Sale
const TotalListSale = () => import('@/views/backend/Sale/totallistsale')
const ListSale = () => import('@/views/backend/Sale/listsale')
const AddSale = () => import('@/views/backend/Sale/addsale')

//pages Logistics
const Logis = () => import('@/views/backend/Logistics/logis')
const LogisInvoice = () => import('@/views/backend/Logistics/logisinvoice')

//pages Purchases
const ListPurchases = () => import('@/views/backend/Purchases/listpurchases')
const AddPurchase = () => import('@/views/backend/Purchases/addpurchase')
const ReqPurchase = () => import('@/views/backend/Purchases/reqpurchase')
const ReqPurchaseTracking = () => import('@/views/backend/Purchases/ReqPurchaseTracking')
const ListReqPurchases = () => import('@/views/backend/Purchases/listreqpurchases')

//pages Returns

//pages Export
const Exportlist = () => import('@/views/backend/Export/exportlist')
const AddExport = () => import('@/views/backend/Export/addexport')

//pages RocketGrowth
const GrowthDB = () => import('@/views/backend/growth/growthdb')
const GrowthSales = () => import('@/views/backend/growth/growthSales')
// const GrowthScm = () => import('@/views/backend/growth/growthScm') // 레거시 - 파일 없음
const GrowthScmV0 = () => import('@/views/backend/growth/growthScmV0')
const GrowthSalesStatus = () => import('@/views/backend/growth/growthSalesStatus')
const GrowthAdsStatus = () => import('@/views/backend/growth/growthAdsStatus')

const GrowthSalesLedger = () => import('@/views/backend/growth/growthSalesLedger')
const GrowthAdManager = () => import('@/views/backend/growth/growthAdManager')
const Nomadreqpo = () => import('@/views/backend/growth/nomadreqpo')
const ReqpurchaseV0 = () => import('@/views/backend/growth/reqpurchaseV0')
const SamplePo = () => import('@/views/backend/growth/samplePo')
const BookkeepingManagement = () => import('@/views/backend/growth/BookkeepingManagement')
const GrowthSourcingBoard = () => import('@/views/backend/growth/growthSourcingBoard')


//pages RocketGrowth
const NomadSourcingmaster = () => import('@/views/backend/nomad/sourcingmaster')
const NomadSourcingmasterTF = () => import('@/views/backend/nomad/sourcingmasterTF')
const NomadSourcingmasterTF2 = () => import('@/views/backend/nomad/sourcingmasterTF2')
const NomadSourcingmasterTS = () => import('@/views/backend/nomad/sourcingmasterTS')
const NomadSourcingmasterv2 = () => import('@/views/backend/nomad/sourcingmasterv2')
const NomadKeywordAnalysis = () => import('@/views/backend/nomad/keywordAnalysis')
const NomadKeywordCollect = () => import('@/views/backend/nomad/keywordCollect')
const KeywordDataCollect = () => import('@/views/backend/Analysis/keywordDataCollect')
const CategorySourcing = () => import('@/views/backend/Analysis/categorySourcing')
const SourcingBoard = () => import('@/views/backend/Analysis/sourcingBoard')
const ProductCompetitiveAnalysis = () => import('@/views/backend/Analysis/productCompetitiveAnalysis')

const ProductTrace = () => import('@/views/backend/nomad/productTrace')
const NomadCategoryAnalysis = () => import('@/views/backend/nomad/keywordCategory')
const NomadCategoryAnalysisNew = () => import('@/views/backend/nomad/categoryAnalysis')
const NomadSaveItem = () => import('@/views/backend/nomad/saveitem')
const NomadSaveItemM = () => import('@/views/backend/nomad/saveitemM')
const NomadSourcingVerify = () => import('@/views/backend/nomad/sourcingVerify')
const NomadUserList = () => import('@/views/backend/nomad/UserList')
const NomadTraffic = () => import('@/views/backend/nomad/traffic')
// const GrowthScm = () => import('@/views/backend/growth/growthScm')

//pages Salesstatus
const Salesstatus = () => import('@/views/backend/Salesstatus/salesstatus')
const Ai = () => import('@/views/backend/Salesstatus/ai')
const Keyword = () => import('@/views/backend/Analysis/keywordAnalysis')
const Keywordoptimize = () => import('@/views/backend/Analysis/keywordOptimize')

const Sourcing = () => import('@/views/backend/Analysis/sourcing')
const Ranking = () => import('@/views/backend/Analysis/ranking')
const ExposureTracking = () => import('@/views/backend/Analysis/exposureTracking')
const AibuyExplorer = () => import('@/views/backend/Analysis/aibuyExplorer')
const Trackingsales = () => import('@/views/backend/Analysis/trackingsales')

//ad
const Adkeyword = () => import('@/views/backend/Ad/adkeyword')
const AdSourcing = () => import('@/views/backend/Ad/adSourcing')
const AdMarketing = () => import('@/views/backend/Ad/adMarketing')

// //pages Import
// const Importlist = () => import('@/views/backend/Import/importlist')
// const AddImport = () => import('@/views/backend/Import/addimport')

//pages Logis
const LogisReqPurchase = () => import('@/views/backend/Logis/logisreqpurchase')
const LogisReqPurchaseV0 = () => import('@/views/backend/Logis/logisreqpurchaseV0')
const StockManagement = () => import('@/views/backend/Logis/stockManagement')
const WarehouseManagement = () => import('@/views/backend/Logis/warehouseManagement')

const LogisNotify = () => import('@/views/backend/Logis/logisnotify')
const LogisAddPurchase = () => import('@/views/backend/Logis/logisaddpurchase')
const LogisPurchaselist = () => import('@/views/backend/Logis/logispurchaselist')
const LogisTotalList = () => import('@/views/backend/Logis/logisTotalList')

const LogisImportBox = () => import('@/views/backend/Logis/logisimportbox')

const LogisAddImport = () => import('@/views/backend/Logis/logisaddimport')
const LogisAddImportV0 = () => import('@/views/backend/Logis/logisaddimportV0')
const LogisInboundListV0 = () => import('@/views/backend/Logis/logisInboundListV0')
const InvoiceRecordList = () => import('@/views/backend/Logis/InvoiceRecordList')
const CoupassProductLabel = () => import('@/views/backend/Logis/CoupassProductLabel')
const InvoiceLicenseList = () => import('@/views/backend/Logis/InvoiceLicenseList')
const CustomsSettlementList = () => import('@/views/backend/Logis/CustomsSettlementList')
const LclBillSplit = () => import('@/views/backend/Logis/LclBillSplit')
const LogisImportErrorListV0 = () => import('@/views/backend/Logis/logisImportErrorListV0')
const LogisPhotoLibraryV0 = () => import('@/views/backend/Logis/logisPhotoLibraryV0')
const LogisPaidOrderListV0 = () => import('@/views/backend/Logis/logisPaidOrderListV0')
const LogisInboundRegisterV0 = () => import('@/views/backend/Logis/logisInboundRegisterV0')
const LogisStockListV0 = () => import('@/views/backend/Logis/logisStockListV0')
const ShipmentRequestList = () => import('@/views/backend/Logis/ShipmentRequestList')
const LogisImportlist = () => import('@/views/backend/Logis/logisimportlist')
const LogisAddExport = () => import('@/views/backend/Logis/logisaddexport')
const LogisExportlist = () => import('@/views/backend/Logis/logisexportlist')
const LogisUserlist = () =>import('@/views/backend/Logis/UserList')
const CoupassStaffAccounts = () => import('@/views/backend/Logis/CoupassStaffAccounts')
const CoupassFeedbackBoard = () => import('@/views/backend/Logis/CoupassFeedbackBoard')
const CoupassCsAssistant = () => import('@/views/backend/Logis/CoupassCsAssistant')

//pages People
const Customers = () => import('@/views/backend/People/customers')
const AddCustomers = () => import('@/views/backend/People/addcustomers')
const Users = () => import('@/views/backend/People/users')
const AddUsers = () => import('@/views/backend/People/addusers')
const Suppliers = () => import('@/views/backend/People/suppliers')
const AddSuppliers = () => import('@/views/backend/People/addsuppliers')

//widget pages
const WidgetSimple = () => import('@/views/backend/Widgets/WidgetSimple')
const WidgetChart = () => import('@/views/backend/Widgets/WidgetChart')

//ui elements

//Form elements
const Datepicker = () => import('@/views/backend/Forms/Form widget/Datepicker')
const Fileupload = () => import('@/views/backend/Forms/Form widget/Fileupload')
const FormQuill = () => import('@/views/backend/Forms/Form widget/FormQuill')
const SelectComponents = () => import('@/views/backend/Forms/Form widget/SelectComponents')
const Simple = () => import('@/views/backend/Forms/Form Wizard/Simple')
const Validate = () => import('@/views/backend/Forms/Form Wizard/Validate')
const Vertical = () => import('@/views/backend/Forms/Form Wizard/Vertical')

//table elements
const DataTable = () => import('@/views/backend/Table/DataTable')
const EditTable = () => import('@/views/backend/Table/EditTable')

//icon elements
const Dripicons = () => import('@/views/backend/Icons/Dripicons')
const FontAwsome = () => import('@/views/backend/Icons/FontAwsome')
const LineAwsome = () => import('@/views/backend/Icons/LineAwsome')
const Remixicons = () => import('@/views/backend/Icons/Remixicons')

//chart elements
const AmChart = () => import('@/views/backend/Chart/AmChart')
const ApexChart = () => import('@/views/backend/Chart/ApexChart')
const HighChart = () => import('@/views/backend/Chart/HighChart')
const MorrisChart = () => import('@/views/backend/Chart/MorrisChart')

//map elements
const GoogleMap = () => import('@/views/backend/Map/GoogleMap')
const VectorMap = () => import('@/views/backend/Map/VectorMap')

//auth elements
const SignIn = () => import('@/views/backend/Auth/SignInModern')
const SignFail = () => import('@/views/backend/Auth/SignFail')
const SignUp = () => import('@/views/backend/Auth/SignUp')
const RecoverPassword = () => import('@/views/backend/Auth/RecoverPassword')
const ForgotPassword = () => import('@/views/backend/Auth/ForgotPassword')
const ResetPassword = () => import('@/views/backend/Auth/ResetPassword')

//pages elements
const ContactDetails = () => import('@/views/backend/Pages/Contact/ContactDetails')
const ContactList = () => import('@/views/backend/Pages/Contact/ContactList')
const Pricing2 = () => import('@/views/backend/Pages/Pricing/Pricing2')
const Pricing4 = () => import('@/views/backend/Pages/Pricing/Pricing4')
const Timeline1 = () => import('@/views/backend/Pages/Timeline/Timeline1')
const Timeline2 = () => import('@/views/backend/Pages/Timeline/Timeline2')
const Timeline3 = () => import('@/views/backend/Pages/Timeline/Timeline3')
const Timeline4 = () => import('@/views/backend/Pages/Timeline/Timeline4')
const FAQ = () => import('@/views/backend/Pages/FAQ')
const Subsribers = () => import('@/views/backend/Pages/Subsribers')

//app element
const EmailComposes = () =>import('@/views/backend/App/Mail/EmailComposes')
const EmailListing = () =>import('@/views/backend/App/Mail/EmailListing')
const UserAccountSetting = () =>import('@/views/backend/App/User Management/UserAccountSetting')
const UserList = () =>import('@/views/backend/App/User Management/UserList')
const userPrivacySettings = () =>import('@/views/backend/App/User Management/UserPrivacySetting')
const UserProfileEdit = () =>import('@/views/backend/App/User Management/UserProfileEdit')
const Chat = () =>import('@/views/backend/App/Chat')
const Todo = () =>import('@/views/backend/App/Todo')
const Accountsetting =() => import('@/views/backend/App/Extraap/AccountSettings')
const privacypolicy = () => import('@/views/backend/App/Extraap/PrivacyPolicy')
const PrivacySettings = () =>import('@/views/backend/App/Extraap/PrivacySettings')
const TermsOfUse = () =>import('@/views/backend/App/Extraap/TermsOfUse')

//admin element
const AdminApiMonitor = () => import('@/views/backend/Admin/AdminApiMonitor')
const UserAuthManager = () => import('@/views/backend/Admin/UserAuthManager')
const AdminGeminiUsage = () => import('@/views/backend/Admin/AdminGeminiUsage')
const ServiceErrorLogs = () => import('@/views/backend/Admin/ServiceErrorLogs')
const AdminChannelState = () => import('@/views/backend/Admin/ChannelState')
const AdminCoupons = () => import('@/views/backend/Admin/AdminCoupons')

//coupass element
const UnifiedPurchase = () => import('@/views/backend/coupass/unifiedPurchaseRequest.vue')

//dashboard element
const MultiAccountDashboard = () => import('@/views/backend/dashboard/multiAccountDashboard.vue')


Vue.use(VueRouter)

const loginchildRoute = () => [
  {
    path: '',
    name: 'auth.login',
    meta: {  name: 'SignIn' },
    component: SignIn
  },
]

const childRoute = () => [
  {
    path: 'dashboard',
    name: 'layout.dashboard1',
    meta: {  name: 'Dashboard1' },
    component: Dashbord
  },
  {
    // 계정마다 쓰는 서비스가 달라 특정 기능 권한으로 묶으면 절반이 못 본다.
    // 여기서 보이는 것은 '내가 연결한 계정' 뿐이라 로그인만 확인하면 된다(requiresAuth 생략).
    path: 'multiAccountDashboard',
    name: 'dashboard.multiAccountDashboard',
    meta: {  name: 'dashboard multiAccountDashboard' },
    component: MultiAccountDashboard
  },
  {
    // 멀티계정관리 창(쿠팡 판매자 계정·쿠팡 쇼핑 계정 저장)을 바로 여는 주소 — screen.open 이 여는 화면(화면 KG 헤더 창).
    // 창은 헤더(HeaderStyle1)가 meta.openModal 을 보고 띄운다. 밑 화면은 대시보드와 같다(로그인만 확인)
    path: 'coupang-accounts',
    name: 'dashboard.coupangAccounts',
    meta: {  name: '멀티계정관리', openModal: 'coupangAccountModal' },
    component: MultiAccountDashboard
  },
  {
    path: 'listproduct',
    name: 'product.listproduct',
    meta: {  name: 'product listproduct', requiresAuth: ['showproduct'] },
    component: ListProduct
  },
  {
    path: 'rocketProductManagement',
    name: 'product.rocketProductManagement',
    meta: {  name: 'rocket product management', requiresAuth: ['showproduct'] },
    component: RocketProductManagement
  },
  {
    path: 'rocketSalesLedger',
    name: 'product.rocketSalesLedger',
    meta: {  name: 'rocket sales ledger', requiresAuth: ['showproduct'] },
    component: RocketSalesLedger
  },
  {
    // 판매자배송 판매장부 — Open API 매출 인식 내역(키 있는 셀러만) · 공개 전까지 개발자만
    path: 'marketplaceSalesLedger',
    name: 'marketplace.salesLedger',
    meta: {  name: 'marketplace sales ledger', requiresAuth: ['showdeveloper'] },
    component: MarketplaceSalesLedger
  },
  {
    // 판매자배송 상품관리 — 윙 상품목록의 판매자배송 옵션 · 공개 전까지 개발자만
    path: 'marketplaceProductManagement',
    name: 'marketplace.productManagement',
    meta: {  name: 'marketplace product management', requiresAuth: ['showdeveloper'] },
    component: MarketplaceProductManagement
  },
  {
    // 판매자배송 공급관리 — 내가 적은 실제 재고 ÷ 30일 하루 평균 = 남은 일수 · 공개 전까지 개발자만
    path: 'marketplaceScm',
    name: 'marketplace.scm',
    meta: {  name: 'marketplace scm', requiresAuth: ['showdeveloper'] },
    component: MarketplaceScm
  },
  {
    path: 'rocketScm',
    name: 'product.rocketScm',
    meta: {  name: 'rocket scm', requiresAuth: ['showproduct'] },
    component: RocketScm
  },
  {
    path: 'regproduct',
    name: 'product.regproduct',
    meta: {  name: 'product regproduct' },
    component: RegProduct
  },
  {
    path: 'AIimage',
    name: 'AI.AIimage',
    meta: {  name: 'AI AIimage', requiresAuth: ['showdeveloper'] },
    component: AIimage
  },
  {
    path: 'CleanUp',
    name: 'AI.CleanUp',
    meta: {  name: 'AI CleanUp', requiresAuth: ['showdeveloper'] },
    component: CleanUp
  },
  {
    path: 'AIRocketReg',
    name: 'AI.AIRocketReg',
    meta: {  name: 'AI AIRocketReg', requiresAuth: ['showRocketReg', 'showdeveloper'] },
    component: AIRocketReg
  },
  {
    path: 'AIAssistant',
    name: 'AI.Assistant',
    meta: {  name: 'AI Assistant', requiresAuth: ['showdeveloper'] },
    component: AIAssistant
  },
  {
    path: 'KnowledgeBase',
    name: 'AI.KnowledgeBase',
    meta: {  name: 'AI KnowledgeBase', requiresAuth: ['showdeveloper'] },
    component: KnowledgeBaseManager
  },
  {
    path: 'NanoBanana',
    name: 'AI.NanoBanana',
    meta: {  name: '나노바나나', requiresAuth: ['showAI'] },
    component: NanoBanana
  },
  {
    path: 'AIpage',
    name: 'AI.AIpage',
    meta: {  name: 'AI AIpage' , requiresAuth: ['showdeveloper'] },
    component: AIpage
  },
  {
    path: 'AIpageV2',
    name: 'AI.AIpageV2',
    meta: {  name: 'AI AIpageV2' , requiresAuth: ['showdeveloper'] },
    component: AIpageV2
  },
  {
    path: 'category',
    name: 'product.category',
    meta: {  name: 'product category' , requiresAuth: ['showsales', 'showlite'] },
    component: Category
  },
  {
    path: 'category_min',
    name: 'product.category_min',
    meta: {  name: 'product category_min' , requiresAuth: ['showMin'] },
    component: CategoryMin
  },
  {
    path: 'addproduct',
    name: 'product.addproduct',
    meta: {  name: 'product addproduct' },
    component: AddProduct
  },
  {
    path: 'listcategory',
    name: 'category.listcategory',
    meta: {  name: 'category listcategory' , requiresAuth: ['showpolist'] },
    component: ListCategory
  },
  {
    path: 'addcategory',
    name: 'category.addcategory',
    meta: {  name: 'category addcategory' },
    component: AddCategory
  },
  {
    path: 'logis',
    name: 'logistics.logis',
    meta: {  name: 'logistics logis' , requiresAuth: ['showimport'] },
    component: Logis
  },
  {
    path: 'logisinvoice',
    name: 'logistics.logisinvoice',
    meta: {  name: 'logistics logisinvoice' , requiresAuth: ['showimport'] },
    component: LogisInvoice
  },
  {
    path: 'listsale',
    name: 'sale.listsale',
    meta: {  name: 'sale listsale' , requiresAuth: ['showstock', 'showadmin'] },
    component: ListSale
  },
  {
    path: 'totallistsale',
    name: 'sale.totallistsale',
    meta: {  name: 'sale totallistsale' , requiresAuth: ['showstock'] },
    component: TotalListSale
  },
  {
    path: 'addsale',
    name: 'sale.addsale',
    meta: {  name: 'sale addsale' , requiresAuth: ['showstock'] },
    component: AddSale
  },
  {
    path: 'listpurchases',
    name: 'purchase.listpurchases',
    meta: {  name: 'purchase listpurchases' , requiresAuth: ['showCoupass', 'showpurchase'] },
    component: ListPurchases
  },
  {
    path: 'listreqpurchases',
    name: 'purchase.listreqpurchases',
    meta: {  name: 'purchase listreqpurchases' },
    component: ListReqPurchases
  },
  {
    path: 'addpurchase',
    name: 'purchase.addpurchase',
    meta: {  name: 'purchase addpurchase' },
    component: AddPurchase
  },
  {
    path: 'reqpurchase',
    name: 'purchase.reqpurchase',
    meta: {  name: 'purchase reqpurchase' , requiresAuth: ['showpurchase', 'showpolist'] },
    component: ReqPurchase
  },
  {
    path: 'reqpurchaseTracking',
    name: 'purchase.reqpurchaseTracking',
    meta: {  name: 'purchase reqpurchaseTracking' , requiresAuth: ['showpurchase'] },
    component: ReqPurchaseTracking
  },
  {
    path: 'customers',
    name: 'people.customers',
    meta: {  name: 'people customers' },
    component: Customers
  },
  {
    path: 'addcustomers',
    name: 'people.addcustomers',
    meta: {  name: 'people addcustomers' },
    component: AddCustomers
  },
  {
    path: 'exportlist',
    name: 'export.exportlist',
    meta: {  name: 'export exportlist' , requiresAuth: ['showexport', 'showadmin'] },
    component: Exportlist
  },
  {
    path: 'addexport',
    name: 'export.addexport',
    meta: {  name: 'export addexport' , requiresAuth: ['showexport'] },
    component: AddExport
  },
  // {
  //   path: 'purchase',
  //   name: 'import.purchase',
  //   meta: {  name: 'import purchase' },
  //   component: Purchase
  // },
  // {
  //   path: 'importlist',
  //   name: 'import.importlist',
  //   meta: {  name: 'import importlist' },
  //   component: Importlist
  // },
  {
    path: 'sourcingmaster',
    name: 'nomad.sourcingmaster',
    meta: {  name: 'nomad sourcingmaster' },
    component: NomadSourcingmaster
  },
  {
    path: 'sourcingmasterv2',
    name: 'nomad.sourcingmasterv2',
    meta: {  name: 'nomad sourcingmasterv2' },
    component: NomadSourcingmasterv2
  },
  {
    path: 'nomadKeywordCollect',
    name: 'nomad.nomadKeywordCollect',
    // 수강생 전용이다. 사이드바 v-if 와 같은 조건을 쓴다 (SidebarStyle.vue).
    // showsales 를 넣지 말 것 — 메뉴에는 안 보이는데 URL 로는 들어가지는 상태가 된다.
    meta: {  name: 'nomad nomadKeywordCollect', screenAuth: true },
    component: NomadKeywordCollect
  },
  {
    path: 'keywordDataCollect',
    name: 'analysis.keywordDataCollect',
    // 수강생 전용. 사이드바는 showKeywordTraffic || shownomad 로 가린다 — 여기도 같게 둔다.
    meta: {  name: 'analysis keywordDataCollect', screenAuth: true },
    component: KeywordDataCollect
  },
  {
    path: 'categorySourcing',
    name: 'analysis.categorySourcing',
    // 수강생 전용. 사이드바는 showKeywordTraffic || shownomad 로 가린다 — 여기도 같게 둔다.
    meta: {  name: 'analysis categorySourcing', screenAuth: true },
    component: CategorySourcing
  },
  {
    path: 'sourcingBoard',
    name: 'analysis.sourcingBoard',
    // 2026-09-18 오픈(comingSoon 제거). requiresAuth 는 담기 3화면과 동일하게 두고 사이드바 조건을 여기에 맞췄다.
    meta: {  name: 'analysis sourcingBoard', screenAuth: true },
    component: SourcingBoard
  },
  {
    path: 'productCompetitiveAnalysis',
    name: 'analysis.productCompetitiveAnalysis',
    meta: {  name: 'analysis productCompetitiveAnalysis', screenAuth: true },
    component: ProductCompetitiveAnalysis
  },
  {
    path: 'productTrace',
    name: 'nomad.productTrace',
    meta: {  name: 'nomad productTrace', screenAuth: true },
    component: ProductTrace
  },
  {
    path: 'nomadKeywordAnalysis',
    name: 'nomad.nomadKeywordAnalysis',
    meta: {  name: 'nomad nomadKeywordAnalysis', screenAuth: true },
    component: NomadKeywordAnalysis
  },
  {
    path: 'nomadCategoryAnalysis',
    name: 'nomad.nomadCategoryAnalysis',
    meta: {  name: 'nomad nomadCategoryAnalysis', screenAuth: true },
    component: NomadCategoryAnalysis
  },
  {
    path: 'categoryAnalysis',
    name: 'nomad.categoryAnalysis',
    meta: {  name: 'nomad categoryAnalysis', requiresAuth: ['showMin'] },
    component: NomadCategoryAnalysisNew
  },
  {
    path: 'sourcingmasterTS',
    name: 'nomad.sourcingmasterTS',
    meta: {  name: 'nomad sourcingmasterTS', screenAuth: true },
    component: NomadSourcingmasterTS
  },
  {
    path: 'sourcingmasterTF',
    name: 'nomad.sourcingmasterTF',
    meta: {  name: 'nomad sourcingmasterTF', screenAuth: true },
    component: NomadSourcingmasterTF
  },
  {
    path: 'sourcingmasterTF2',
    name: 'nomad.sourcingmasterTF2',
    meta: {  name: 'nomad sourcingmasterTF2', screenAuth: true },
    component: NomadSourcingmasterTF2
  },
  {
    path: 'saveitem',
    name: 'nomad.saveitem',
    meta: {  name: 'nomad saveitem' },
    component: NomadSaveItem
  },
  {
    path: 'saveitemM',
    name: 'nomad.saveitemM',
    meta: {  name: 'nomad saveitemM', screenAuth: true },
    component: NomadSaveItemM
  },
  {
    path: 'sourcingVerify',
    name: 'nomad.sourcingVerify',
    meta: {  name: 'nomad sourcingVerify' },
    component: NomadSourcingVerify
  },
  {
    path: 'nomadreqpo',
    name: 'nomad.nomadreqpo',
    meta: {  name: 'nomad nomadreqpo' , requiresAuth: ['showCoupass'] },
    component: Nomadreqpo
  },
  {
    path: 'reqpurchaseV0',
    name: 'nomad.reqpurchaseV0',
    meta: {  name: 'nomad reqpurchaseV0' , requiresAuth: ['showCoupass', 'showpurchase', 'showproduct'] },
    component: ReqpurchaseV0
  },
  {
    path: 'nomadtraffic',
    name: 'nomad.nomadtraffic',
    meta: {  name: 'nomad nomadtraffic' , screenAuth: true },
    component: NomadTraffic
  },
  {
    path: 'nomaduserlist',
    name: 'nomad.userlist',
    meta: {  name: 'nomad userlist' , screenAuth: true },
    component: NomadUserList
  },
  {
    path: 'growthdb',
    name: 'growth.growthdb',
    meta: {  name: 'growth growthdb', requiresAuth: ['showgrowth', 'showSCM'] },
    component: GrowthDB
  },
  {
    path: 'growthSourcingBoard',
    name: 'growth.sourcingBoard',
    // 로켓그로스 구독자 전체(상품관리와 같은 조건). 수강생 데이터를 쓰는 컬럼을 뺐으므로
    // shownomad 로 묶지 않는다. 분석(수강생) 소싱관리는 그대로 shownomad 다.
    meta: {  name: 'growth sourcingBoard', requiresAuth: ['showgrowth', 'showSCM'] },
    component: GrowthSourcingBoard
  },
  {
    path: 'samplePo',
    name: 'growth.samplePo',
    meta: {  name: 'growth samplePo' , requiresAuth: ['showCoupass'] },
    component: SamplePo
  },
  {
    path: 'growthsales',
    name: 'growth.growthsales',
    meta: {  name: 'growth growthsales' , requiresAuth: ['showgrowth', 'showSCM'] },
    component: GrowthSales
  },
  // growthScm 레거시 라우트 - 파일 없음, V0로 대체
  // {
  //   path: 'growthscm',
  //   name: 'growth.growthscm',
  //   meta: {  name: 'growth growthscm', requiresAuth: ['showgrowth', 'showSCM'] },
  //   component: GrowthScm
  // },
  {
    path: 'growthscmV0',
    name: 'growth.growthscmV0',
    meta: {  name: 'growth growthscmV0', requiresAuth: ['showgrowth', 'showSCM'] },
    component: GrowthScmV0
  },
  {
    path: 'salesstatus',
    name: 'growth.salesstatus',
    meta: {  name: 'growth salesstatus' , requiresAuth: ['showgrowth', 'showSCM'] },
    component: GrowthSalesStatus
  },
  {
    path: 'adsstatus',
    name: 'growth.adsstatus',
    meta: {  name: 'growth adsstatus' , requiresAuth: ['showgrowth', 'showSCM'] },
    component: GrowthAdsStatus
  },
  {
    path: 'salesledger',
    name: 'growth.salesledger',
    meta: {  name: 'growth salesledger' , requiresAuth: ['showgrowth', 'showSCM'] },
    component: GrowthSalesLedger
  },
  {
    path: 'admanager',
    name: 'growth.admanager',
    meta: {  name: 'growth admanager' , requiresAuth: ['showAdManager'] },
    component: GrowthAdManager
  },
  {
    path: 'bookkeeping',
    name: 'growth.bookkeeping',
    meta: {  name: 'growth bookkeeping' , requiresAuth: ['showgrowth', 'showSCM'] },
    component: BookkeepingManagement
  },


  {
    path: 'salesstatus',
    name: 'salesstatus.salesstatus',
    meta: {  name: 'Salesstatus salesstatus' , requiresAuth: ['showproduct'] },
    component: Salesstatus
  },
  {
    path: 'ai',
    name: 'salesstatus.ai',
    meta: {  name: 'Salesstatus ai' , requiresAuth: ['showproduct', 'showsales'] },
    component: Ai
  },
  {
    path: 'keyword',
    name: 'analysis.keyword',
    meta: {  name: 'Analysis keyword', requiresAuth: ['showsales', 'showlite', 'showKeywordAnalysis'] },
    component: Keyword
  },
  {
    path: 'keywordoptimize',
    name: 'analysis.keywordoptimize',
    meta: {  name: 'Analysis keywordoptimize', requiresAuth: ['showsales', 'makeProductName'] },
    component: Keywordoptimize
  },
  {
    path: 'adkeyword',
    name: 'Ad.adkeyword',
    meta: {  name: 'Ad adkeyword' },
    component: Adkeyword
  },
  {
    path: 'adSourcing',
    name: 'Ad.adSourcing',
    meta: {  name: 'Ad adSourcing' , screenAuth: true },
    component: AdSourcing
  },
  {
    path: 'adMarketing',
    name: 'Ad.adMarketing',
    meta: {  name: 'Ad adMarketing' },
    component: AdMarketing
  },
  {
    path: 'sourcing',
    name: 'analysis.sourcing',
    meta: {  name: 'Analysis sourcing' , requiresAuth: ['showsales'] },
    component: Sourcing
  },
  {
    path: 'ranking',
    name: 'analysis.ranking',
    meta: {  name: 'Analysis ranking' , requiresAuth: ['showsales', 'showlite', 'showCollectRank'] },
    component: Ranking
  },
  {
    path: 'exposureTracking',
    name: 'analysis.exposureTracking',
    meta: { name: 'Analysis exposureTracking' , screenAuth: true },
    component: ExposureTracking
  },
  {
    path: 'aibuyExplorer',
    name: 'analysis.aibuyExplorer',
    meta: { name: '1688탐색' },
    component: AibuyExplorer
  },
  {
    path: 'trackingsales',
    name: 'analysis.trackingsales',
    meta: {  name: 'Analysis trackingsales' , requiresAuth: ['showsales', 'showlite'] },
    component: Trackingsales
  },
  // {
  //   path: 'addimport',
  //   name: 'import.addimport',
  //   meta: {  name: 'import addimport' },
  //   component: AddImport
  // },
  {
    path: 'logisimportlist',
    name: 'logis.logisimportlist',
    meta: {  name: 'logis logisimportlist' , requiresAuth: ['showadmin'] },
    component: LogisImportlist
  },
  {
    path: 'logisnotify',
    name: 'logis.logisnotify',
    meta: {  name: 'logis logisnotify' , requiresAuth: ['showadmin'] },
    component: LogisNotify
  },
  {
    path: 'logisaddimport',
    name: 'logis.logisaddimport',
    meta: {  name: 'logis logisaddimport' , requiresAuth: ['showadmin'] },
    component: LogisAddImport
  },
  {
    path: 'logisaddimportV0',
    name: 'logis.logisaddimportV0',
    meta: {  name: 'logis logisaddimportV0' , requiresAuth: ['showadmin'] },
    component: LogisAddImportV0
  },
  {
    path: 'logisinboundlist',
    name: 'logis.logisinboundlist',
    meta: {  name: 'logis logisinboundlist' , requiresAuth: ['showadmin'] },
    component: LogisInboundListV0
  },
  {
    // 入库列表 의 「待客户确认」 — 같은 화면을 상태만 고정해 연다(사이드바에서 代办列表 바로 아래, 2026-10-04 YZY)
    path: 'logisinboundconfirm',
    name: 'logis.logisinboundconfirm',
    meta: {  name: 'logis logisinboundconfirm' , requiresAuth: ['showadmin'], inboundStatus: '출고확인대기' },
    component: LogisInboundListV0
  },
  {
    path: 'logisimporterrorlist',
    name: 'logis.logisimporterrorlist',
    meta: {  name: 'logis logisimporterrorlist' , requiresAuth: ['showadmin'] },
    component: LogisImportErrorListV0
  },
  {
    // 扫码上传入库资料 — 박스 입고자료 폰 업로드 QR(2026-10-18 杨英文 #82)
    path: 'boxphotoscan',
    name: 'logis.boxphotoscan',
    meta: {  name: 'logis boxphotoscan' , requiresAuth: ['showadmin'] },
    component: () => import('@/views/backend/Logis/BoxPhotoScan.vue')
  },
  {
    // 货主 ↔ 组长负责人 관리(2026-10-18 崔凡 #81)
    path: 'ownerleader',
    name: 'logis.ownerleader',
    meta: {  name: 'logis ownerleader' , requiresAuth: ['showadmin'] },
    component: () => import('@/views/backend/Logis/OwnerLeaderManage.vue')
  },
  {
    // 박스별 입고자료 사진 현황(2026-10-16 杨英文 #56)
    path: 'boxphotostatus',
    name: 'logis.boxphotostatus',
    meta: {  name: 'logis boxphotostatus' , requiresAuth: ['showadmin'] },
    component: () => import('@/views/backend/Logis/BoxPhotoStatus.vue')
  },
  {
    path: 'logisphotolibrary',
    name: 'logis.logisphotolibrary',
    meta: {  name: 'logis logisphotolibrary' , requiresAuth: ['showadmin'] },
    component: LogisPhotoLibraryV0
  },
  {
    path: 'logispaidorderlist',
    name: 'logis.logispaidorderlist',
    meta: {  name: 'logis logispaidorderlist' , requiresAuth: ['showadmin'] },
    component: LogisPaidOrderListV0
  },
  {
    path: 'logisinboundregister',
    name: 'logis.logisinboundregister',
    meta: {  name: 'logis logisinboundregister' , requiresAuth: ['showadmin'] },
    component: LogisInboundRegisterV0
  },
  {
    path: 'logisstocklist',
    name: 'logis.logisstocklist',
    meta: {  name: 'logis logisstocklist' , requiresAuth: ['showadmin'] },
    component: LogisStockListV0
  },
  {
    // 货主库存出库(화주 재고 출고요청) — 库存列表 탭에서 독립 메뉴로(2026-10 YZY)
    path: 'logisshipoutrequest',
    name: 'logis.logisshipoutrequest',
    meta: {  name: 'logis logisshipoutrequest' , requiresAuth: ['showadmin'] },
    component: ShipmentRequestList
  },
  {
    path: 'logisimportbox',
    name: 'logis.logisimportbox',
    meta: {  name: 'logis logisimportbox' , requiresAuth: ['showadmin'] },
    component: LogisImportBox
  },
  {
    path: 'logisexportlist',
    name: 'logis.logisexportlist',
    meta: {  name: 'logis logisexportlist' , requiresAuth: ['showadmin'] },
    component: LogisExportlist
  },
  {
    path: 'logisuserlist',
    name: 'logis.logisuserlist',
    meta: {  name: 'logis logisuserlist' , requiresAuth: ['showadmin'] },
    component: LogisUserlist
  },
  {
    // 쿠패스 대표 전용 — 메뉴 노출·API 모두 서버가 대표 여부를 판정한다(/api/coupass-staff/*)
    path: 'staffaccounts',
    name: 'logis.staffaccounts',
    meta: {  name: 'logis staffaccounts' , requiresAuth: ['showadmin'] },
    component: CoupassStaffAccounts
  },
  {
    // 요청 진행 현황 — 쿠패스 직원 읽기 전용(2026-10 YZY). 서버 /api/coupass-feedback/list 도 showadmin 만
    path: 'feedbackboard',
    name: 'logis.feedbackboard',
    meta: {  name: 'logis feedbackboard' , requiresAuth: ['showadmin'] },
    component: CoupassFeedbackBoard
  },
  {
    // 客服助手(cs 빌드 확장) 다운로드·사용법 — 파일은 /api/cs/extension/* 가 관리자 권한 뒤에서 준다
    path: 'csassistant',
    name: 'logis.csassistant',
    meta: {  name: 'logis csassistant' , requiresAuth: ['showadmin'] },
    component: CoupassCsAssistant
  },
  {
    path: 'logisaddexport',
    name: 'logis.logisaddexport',
    meta: {  name: 'logis logisaddexport' , requiresAuth: ['showadmin'] },
    component: LogisAddExport
  },
  {
    path: 'logispurchaselist',
    name: 'logis.logispurchaselist',
    meta: {  name: 'logis logispurchaselist' , requiresAuth: ['showadmin'] },
    component: LogisPurchaselist
  },
  {
    path: 'logisTotalList',
    name: 'logis.logisTotalList',
    meta: {  name: 'logis logisTotalList' , requiresAuth: ['showadmin'] },
    component: LogisTotalList
  },
  {
    path: 'logisreqpurchase',
    name: 'logis.logisreqpurchase',
    meta: {  name: 'logis logisreqpurchase' , requiresAuth: ['showadmin'] },
    component: LogisReqPurchase
  },
  {
    path: 'logisreqpurchaseV0',
    name: 'logis.logisreqpurchaseV0',
    meta: {  name: 'logis logisreqpurchaseV0' , requiresAuth: ['showadmin'] },
    component: LogisReqPurchaseV0
  },
  {
    // 进度管理(구매내역관리)는 商品求购 화면 안 탭으로 들어갔다(2026-10 YZY) — 옛 주소는 그 탭으로 보낸다
    path: 'logisReqpurchaseTracking',
    name: 'logis.reqpurchaseTracking',
    meta: {  name: 'logis reqpurchaseTracking' , requiresAuth: ['showadmin'] },
    redirect: { name: 'logis.logisreqpurchaseV0', query: { view: 'tracking' } }
  },
  {
    path: 'stockmanagement',
    name: 'logis.stockmanagement',
    meta: {  name: 'logis stockmanagement' , requiresAuth: ['showCoupass', 'showadmin'] },
    component: StockManagement
  },
  {
    path: 'warehousemanagement',
    name: 'logis.warehousemanagement',
    meta: {  name: 'logis warehousemanagement' , requiresAuth: ['showadmin'] },
    component: WarehouseManagement
  },
  // 待手动匹配 — 별도 메뉴였다가 出库列表 의 待出库列表 탭 안(맨 위 구역)으로 합쳤다(2026-10-07 YZY 「合并」).
  // 옛 주소는 그 탭으로 보낸다(view=manual)
  {
    path: 'outboundmanualmatch',
    name: 'logis.outboundmanualmatch',
    meta: {  name: 'logis outboundmanualmatch' , requiresAuth: ['showadmin'] },
    redirect: { name: 'logis.warehousemanagement', query: { view: 'manual' } }
  },
  // 箱单发票列表 — 만든 箱单发票·产地证 기록, 提单BL·产地证 核对件/正本, 出库资料文件(2026-10-04 YZY)
  {
    path: 'invoicerecords',
    name: 'logis.invoicerecords',
    meta: {  name: 'logis invoicerecords' , requiresAuth: ['showadmin'] },
    component: InvoiceRecordList
  },
  // 韩文标签资料 — 화주·바코드별 식검/KC 한글표시사항 + KC 인증서류. 入库处理 라벨 출력·箱单发票列表 KC证书 가 읽는다(2026-10-07 YZY)
  {
    path: 'productlabels',
    name: 'logis.productlabels',
    meta: {  name: 'logis productlabels' , requiresAuth: ['showadmin'] },
    component: CoupassProductLabel
  },
  // 营业执照管理 — 화주별 사업자등록증(한 화주에 여러 장). 箱单发票 만들 때 여기서 올린 것 중 고른다(2026-10-04 YZY)
  {
    path: 'invoicelicenses',
    name: 'logis.invoicelicenses',
    meta: {  name: 'logis invoicelicenses' , requiresAuth: ['showadmin'] },
    component: InvoiceLicenseList
  },
  // 关税结算单 — 관세사 청구서·정산서·수입신고필증 BL별 업로드·분할 저장·미업로드 표시(2026-10-06 주인·YZY)
  {
    path: 'customssettlement',
    name: 'logis.customssettlement',
    meta: {  name: 'logis customssettlement' , requiresAuth: ['showadmin'] },
    component: CustomsSettlementList
  },
  // 통합통관 청구서 나누기 — LCL 표 고객 행마다 청구서 서식을 채워 고객별 파일(2026-10-07 YZY). 시스템 저장 안 함(임시 도구)
  {
    path: 'lclbillsplit',
    name: 'logis.lclbillsplit',
    meta: {  name: 'logis lclbillsplit' , requiresAuth: ['showadmin'] },
    component: LclBillSplit
  },
  // 请求变更记录은 商品求购(logisreqpurchaseV0) 안 탭으로 옮겼다(2026-10-03). 옛 주소·북마크는 그 탭으로 보낸다
  {
    path: 'logisreqchanges',
    name: 'logis.logisreqchanges',
    redirect: { name: 'logis.logisreqpurchaseV0', query: { view: 'changes' } }
  },
  {
    path: 'logisaddpurchase',
    name: 'logis.logisaddpurchase',
    meta: {  name: 'logis logisaddpurchase' , requiresAuth: ['showadmin'] },
    component: LogisAddPurchase
  },
  {
    path: 'users',
    name: 'people.users',
    meta: {  name: 'people users' , requiresAuth: ['showdeveloper'] },
    component: Users
  },
  {
    path: 'addusers',
    name: 'people.addusers',
    meta: {  name: 'people addusers' , requiresAuth: ['showdeveloper'] },
    component: AddUsers
  },
  {
    path: 'suppliers',
    name: 'people.suppliers',
    meta: {  name: 'people suppliers' },
    component: Suppliers
  },
  {
    path: 'addsuppliers',
    name: 'people.addsuppliers',
    meta: {  name: 'people addsuppliers' },
    component: AddSuppliers
  },
  {
    path: 'widget-simple',
    name: 'widget.simple',
    meta: {  name: 'Widget Simple' },
    component: WidgetSimple
  },
  {
    path: 'widget-chart',
    name: 'widget.chart',
    meta: {  name: 'Widget Chart'},
    component: WidgetChart
  },
  {
    path: 'form-datepicker',
    name: 'widget.form-datepicker',
    meta: {  name: 'Form Datepicker' },
    component:Datepicker
  },
  {
    path: 'form-file-uploader',
    name: 'widget.form-file-uploader',
    meta: {  name: 'Form Fileupload' },
    component:Fileupload
  },
  {
    path: 'form-quill',
    name: 'widget.form-quill',
    meta: {  name: 'Form quill' },
    component:FormQuill
  },
  {
    path: 'form-select',
    name: 'widget.form-select',
    meta: {  name: 'Form Select2' },
    component:SelectComponents
  },
  {
    path: 'form-wizard',
    name: 'wizard.form-wizard',
    meta: {  name: 'Form Wizard' },
    component:Simple
  },{
    path: 'form-wizard-validate',
    name: 'wizard.form-wizard-validate',
    meta: {  name: 'Form Wizard Validate' },
    component:Validate
  },{
    path: 'form-wizard-vertical',
    name: 'wizard.form-wizard-vertical',
    meta: {  name: 'Form Wizard Vertical' },
    component:Vertical
  },
  {
    path: 'data-table',
    name: 'table.data-table',
    meta: {  name: 'Data Table ' },
    component:DataTable
  },
  {
    path: 'edit-table',
    name: 'table.edit-table',
    meta: {  name: 'Edit Table ' },
    component:EditTable
  },
  {
    path: 'icon-dripicons',
    name: 'icon.dripicon',
    meta: {  name: 'Dripicons ' },
    component:Dripicons
  },{
    path: 'icon-fontawsome',
    name: 'icon.fontawsome',
    meta: {  name: 'FontAwsome ' },
    component:FontAwsome
  },{
    path: 'icon-lineawsome',
    name: 'icon.lineawsome',
    meta: {  name: 'LineAwsome ' },
    component:LineAwsome
  },{
    path: 'icon-remixicon',
    name: 'icon.remixicon',
    meta: {  name: 'Remixicon ' },
    component:Remixicons
  },
  {
    path: 'am-chart',
    name: 'chart.amchart',
    meta: {  name: 'Amchart' },
    component:AmChart
  },
  {
    path: 'apex-chart',
    name: 'chart.apexchart',
    meta: {  name: 'Apexchart' },
    component:ApexChart
  },
  {
    path: 'high-chart',
    name: 'chart.highchart',
    meta: {  name: 'Highchart' },
    component:HighChart
  },
  {
    path: 'morris-chart',
    name: 'chart.morrischart',
    meta: {  name: 'Morrischart' },
    component:MorrisChart
  },
  {
    path: 'google-map',
    name: 'map.google',
    meta: {  name: 'Google Map' },
    component:GoogleMap
  },
  {
    path: 'vector-map',
    name: 'map.vector',
    meta: {  name: 'Vector Map' },
    component:VectorMap
  },
  {
    path: 'user-list',
    name: 'app.user-list',
    meta: {  name: 'UserList' },
    component:UserList
  },
  {
    path: 'email-composes',
    name: 'app.email-composes',
    meta: {  name: 'email-compose' },
    component:EmailComposes
  },
  {
    path: 'email-listing',
    name: 'app.email-listing',
    meta: {  name: 'email listing' },
    component:EmailListing
  },
  {
    path: 'user-privacy-settings',
    name: 'app.user-privacy-setting',
    meta: {  name: 'user-privacy-setting' },
    component:userPrivacySettings
  },
  {
    path: 'User-profile-edit',
    name: 'app.user-profile-edit',
    meta: {  name: 'user-profile-edit' },
    component:UserProfileEdit
  },
  {
    path: 'User-account-setting',
    name: 'app.user-Account-setting',
    meta: {  name: 'user account setting' },
    component:UserAccountSetting
  },
  {
    path: 'chat',
    name: 'app.chat',
    meta: {  name: 'Chat' },
    component:Chat
  },
  {
    path: 'todo',
    name: 'app.todo',
    meta: {  name: 'Todo' },
    component:Todo
  },
  {
    path: 'privacy-settings',
    name: 'app.Privacysettings',
    meta: {  name: 'Privacysettings' },
    component:PrivacySettings
  },
  {
    path: 'terms-of-use',
    name: 'app.Termsofuse',
    meta: {  name: 'Termsofuse' },
    component:TermsOfUse
  },
  {
    path: 'privacy-policy',
    name: 'app.privacypolicy',
    meta: {  name: 'privacypolicy' },
    component:privacypolicy
  },
  {
    path: 'account-setting',
    name: 'app.Accountsetting',
    meta: {  name: 'Accountsetting' },
    component:Accountsetting
  },
  {
    path: 'admin-api-monitor',
    name: 'admin.api-monitor',
    meta: {  name: 'API 모니터링', requiresAuth: ['showdeveloper'] },
    component: AdminApiMonitor
  },
  {
    path: 'user-auth-manager',
    name: 'admin.user-auth-manager',
    meta: {  name: '사용자 권한 관리' , requiresAuth: ['showdeveloper'] },
    component: UserAuthManager
  },
  {
    path: 'admin-gemini-usage',
    name: 'admin.gemini-usage',
    meta: {  name: 'Gemini 사용량', requiresAuth: ['showdeveloper'] },
    component: AdminGeminiUsage
  },
  {
    path: 'service-error-logs',
    name: 'admin.service-error-logs',
    meta: {  name: '서비스 에러 로그', requiresAuth: ['showdeveloper'] },
    component: ServiceErrorLogs
  },
  {
    path: 'admin-channel-state',
    name: 'admin.channel-state',
    meta: {  name: '계정 채널 상태', requiresAuth: ['showdeveloper'] },
    component: AdminChannelState
  },
  {
    path: 'admin-coupons',
    name: 'admin.coupons',
    meta: {  name: '쿠폰 발급', requiresAuth: ['showadmin'] },
    component: AdminCoupons
  },
  {
    path: 'unified-purchase',
    name: 'coupass.unified-purchase',
    meta: {  name: '통합 구매 요청' },
    component: UnifiedPurchase
  },
  {
    path: 'unified-purchase-v2',
    name: 'coupass.unified-purchase-v2',
    meta: {  name: '통합 구매 요청 V2' , requiresAuth: ['showCoupass', 'showpurchase'] },
    component: () => import('@/views/backend/coupass/unifiedPurchaseRequestV2.vue')
  },

]
const authchildRoute = () =>[
  // {
  //   path: 'sign-in',
  //   name: 'auth.login',
  //   meta: {  name: 'SignIn' },
  //   component: SignIn
  // },
  {
    path: 'sign-fail',
    name: 'auth.loginfail',
    meta: {  name: 'SignFail' },
    component: SignFail
  },
  {
    path: 'sign-up',
    name: 'auth.register',
    meta: {  name: 'SignUp' },
    component: SignUp
  },
  {
    path: 'recover-password',
    name: 'auth.recover-password',
    meta: {  name: 'Recover Password' },
    component: RecoverPassword
  },
  {
    path: 'forgot-password',
    name: 'auth.forgot-password',
    meta: {  name: 'Forgot Password' },
    component: ForgotPassword
  },
  {
    path: 'reset-password/:token',
    name: 'auth.reset-password',
    meta: {  name: 'Reset Password' },
    component: ResetPassword
  },

]
const pageschildRoute = () =>[
  // 입고 핸드폰 촬영 — 로그인 없이 QR 토큰으로 연다(/pages 는 라우터 가드 제외, App.vue 로그인 이동도 제외)
  {
    path: 'import-photo/:id',
    name: 'pages.importPhoto',
    meta: {  name: 'Import Photo' },
    component: () => import('@/views/backend/Logis/ImportPhotoMobile.vue')
  },
  // 박스별 입고자료 촬영(2026-10-16 杨英文 #56) — 박스 라벨의 QR 로 연다. 로그인 없이 QR 안의 서명(?t=)으로 동작
  {
    path: 'import-photo-box/:labelId',
    name: 'pages.boxPhoto',
    meta: {  name: 'Box Photo' },
    component: () => import('@/views/backend/Logis/BoxPhotoMobile.vue')
  },
  // 入库资料 연속 업로드(2026-10-18 杨英文 #56) — «Coupang入库资料» 창의 QR 로 연다. 박스 바코드를 스캔해 가며 이어서 올린다. 로그인 없이 QR 안의 세션 서명(?t=)으로 동작
  {
    path: 'import-photo-session',
    name: 'pages.boxPhotoSession',
    meta: {  name: 'Box Photo Session' },
    component: () => import('@/views/backend/Logis/BoxPhotoSession.vue')
  },
]
const extrapageschildRoute = () =>[
  {
    path: 'contact-detail',
    name: 'contact.detail',
    meta: {  name: 'Contact Detail' },
    component: ContactDetails
  },
  {
    path: 'contact-list',
    name: 'contact.list',
    meta: {  name: 'Contact List' },
    component: ContactList
  },
  {
    path: 'timeline-1',
    name: 'time.line',
    meta: {  name: 'TimeLine-1' },
    component: Timeline1
  },
  {
    path: 'timeline-2',
    name: 'time.line1',
    meta: {  name: 'TimeLine-2' },
    component: Timeline2
  },
  {
    path: 'timeline-3',
    name: 'time.line2',
    meta: {  name: 'TimeLine-3' },
    component: Timeline3
  },
  {
    path: 'timeline-4',
    name: 'time.line3',
    meta: {  name: 'TimeLine-4' },
    component: Timeline4
  },
  {
    path: 'pricing-2',
    name: 'price.pay1',
    meta: {  name: 'Pricing-2' },
    component: Pricing2
  },
  {
    path: 'pricing-4',
    name: 'price.pay3',
    meta: {  name: 'Pricing-4' },
    component: Pricing4
  },
  {
    path: 'pages-subscriber',
    name: 'pages.subscribers',
    meta: {  name: 'Pages Subscribers' },
    component: Subsribers
  },
  {
    path: 'pages-faq',
    name: 'pages.faq',
    meta: {  name: 'Pages FAQ' },
    component: FAQ
  },
]

const routes = [
  {
    path: '/',
    name: '',
    component: BlankLayout,
    children: loginchildRoute()
  },
  {
    path: '/',
    name: '',
    component: Layout1,
    children: childRoute()
  },
  {
    path: '/auth',
    name: 'auth',
    component: BlankLayout,
    children: authchildRoute()
  },
  {
    path: '/pages',
    name: 'pages',
    component: BlankLayout,
    children: pageschildRoute()
  },
  {
    path: '/extra-pages',
    name: 'extra-pages',
    component: Layout1,
    children: extrapageschildRoute()
  },
  {
    // 쿠패스 핸드폰 화면(사이드바 없는 한 페이지) — 일반 로그인 세션 필요(직원 계정 showadmin). /pages 와 달리 라우터 가드를 탄다
    path: '/m',
    component: BlankLayout,
    children: [
      {
        path: 'putaway',
        name: 'mobile.putaway',
        meta: {  name: 'Mobile Putaway' , requiresAuth: ['showadmin'] },
        component: () => import('@/views/backend/Logis/MobilePutaway.vue')
      },
      {
        // 핸드폰 入仓登记 — 운송장 스캔 → 촬영 → 위치번호 스캔 → 入仓(2026-10-04 YZY)
        path: 'inbound-register',
        name: 'mobile.inboundregister',
        meta: {  name: 'Mobile Inbound Register' , requiresAuth: ['showadmin'] },
        component: () => import('@/views/backend/Logis/MobileInboundRegister.vue')
      },
      {
        // 핸드폰 入库拍照 — 单号 스캔 → 商品/尺寸照片 → 完成 → PC 入库处理 하단 대기열(2026-10-07 YZY). 入仓登记 화면을 mode 로 재사용
        path: 'import-photo',
        name: 'mobile.importphoto',
        meta: {  name: 'Mobile Import Photo' , requiresAuth: ['showadmin'] },
        props: { mode: 'photo' },
        component: () => import('@/views/backend/Logis/MobileInboundRegister.vue')
      }
    ]
  },
  {
    // 모르는 주소 — 흰 화면 대신 «찾는 화면이 없어요»(cpl-x1-unknownroute-1) · 맨 끝에 둔다(앞 길을 가리지 않게)
    path: '*',
    name: 'pages.notfound',
    meta: {  name: 'Not Found' },
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

// 권한 체크 함수
function hasPermission(userAuth, requiredPermissions) {
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true; // 권한이 필요하지 않은 페이지
  }

  // OR 조건: 하나라도 권한이 있으면 접근 허용
  return requiredPermissions.some(permission => {
    if (permission === 'showlite') {
      // showlite는 addAccount가 false일 때만 허용
      return !store.state.user.addAccount && userAuth[permission];
    } else if (permission === 'showsales') {
      // showsales는 addAccount가 있거나 auth.showsales가 있으면 허용
      return store.state.user.addAccount || userAuth[permission];
    }
    return userAuth[permission];
  });
}

// Router Guard 설정
router.beforeEach(async (to, from, next) => {
  // 개발 모드에서는 인증/권한 체크 스킵 (npm run serve)
  if (process.env.NODE_ENV === 'development') {
    next();
    return;
  }

  // 로그인 페이지나 인증 관련 페이지는 권한 체크 제외
  if (to.name === 'auth.login' || to.path.startsWith('/auth') || to.path.startsWith('/pages')) {
    next();
    return;
  }

  // 새로고침·URL 직접 진입 시 store가 비어 있으므로 로그인 정보 로드를 기다린다.
  // (기다리지 않고 통과시키면 권한 체크가 아예 동작하지 않음)
  await store.dispatch('ensureAuth');

  // 미로그인 상태면 로그인 페이지로
  if (!store.state.user._id) {
    next({ name: 'auth.login' });
    return;
  }

  // 오픈 전 화면 — 사이드바에서 숨기는 것만으로는 주소를 아는 사람이 그대로 들어온다.
  // meta.comingSoon 이 달린 라우트는 권한과 무관하게 대시보드로 보낸다.
  if (to.meta.comingSoon) {
    next({ name: 'layout.dashboard1' });
    return;
  }

  // 사용자 권한 정보 가져오기
  const userAuth = store.state.user.auth || {};
  const requiredPermissions = to.meta.requiresAuth;
  // 수강생 화면(meta.screenAuth) = 사이드바에 보이는 조건 그대로 — utils/screenAuth.js 한 곳(사이드바·서버 API·확장도 같은 표)
  const denied = to.meta.screenAuth
    ? !canSeeScreen(store.state.user, to.name)
    : (requiredPermissions && !hasPermission(userAuth, requiredPermissions));

  // 권한 체크
  if (denied) {
    // 무한 루프 방지: 이미 리다이렉트 대상 페이지라면 강제로 진행
    if (to.name === 'layout.dashboard1' || to.name === 'analysis.keywordoptimize') {
      next();
      return;
    }

    // 권한이 없으면 사용자가 접근 가능한 페이지로 리다이렉트
    if (userAuth.showsales || userAuth.makeProductName) {
      next({ name: 'analysis.keywordoptimize' });
    } else {
      // 어떤 권한도 없으면 대시보드로 (빈 화면이어도 에러는 안남)
      next({ name: 'layout.dashboard1' });
    }
  } else {
    next(); // 정상 진행
  }
});

// 쿠패스 화면은 브라우저 탭 제목도 사이드바 메뉴 이름과 같게(views/backend/Logis/coupassMenu.js 한 곳)
const DEFAULT_TITLE = document.title
router.afterEach((to) => {
  const t = coupassMenuTitle(to.name)
  document.title = t ? t + ' - COUPLUS' : DEFAULT_TITLE
})

export default router
